import { usePropertyStore } from "../../store/usePropertyStore";
import { formatRupiah } from "../../utils/formatter";

const Sidebar = () => {
    const { properties, advancedFilter, setAdvancedFilter } = usePropertyStore();
    const { types = [], harga = [], provinces = [], cities = [] } = advancedFilter || {};

    const toggleFilter = (category, value) => {
        const arr = advancedFilter[category] || [];
        const updated = arr.includes(value) ? arr.filter((v) => v !== value) : [...arr, value];

        setAdvancedFilter(category, updated);
        setAdvancedFilter("page", 1);
    };

    //
    const safeProperties = Array.isArray(properties) ? properties.map((p) => ({
        ...p,
        property_type: p?.property_type ?? "-",
        facilities: {
            bed: p?.facilities?.bed ?? 0,
            bath: p?.facilities?.bath ?? 0,
            sqm: p?.facilities?.sqm ?? 0,
        },
        rent: {
            price: p?.rent_price ?? 0,
            type: p?.rent_type ?? "bulan",
        },
    })) : [];

    const typesList = [...new Set(safeProperties.map((p) => p.property_type))];
    const typeCount = typesList.map((t) => ({
        type: t,
        count: safeProperties.filter((p) => p.property_type === t).length,
    }));

    const hargaRanges = [
        { label: "Budget Rendah", key: "low", min: 0, max: 2000000 },
        { label: "Menengah", key: "medium", min: 2000000, max: 5000000 },
        { label: "Tinggi", key: "high", min: 5000000, max: Infinity },
    ];

    const hargaCount = hargaRanges.map((r) => ({
        ...r,
        count: safeProperties.filter((p) => p.rent.price >= r.min && p.rent.price < r.max).length,
    }));

    const provincesList = [...new Set(safeProperties.map((p) => p.province))].filter(Boolean);
    const provincesCount = provincesList.map((province) => ({
        province: province,
        count: safeProperties.filter((p) => p.province === province).length,
    }));

    const citiesList = [...new Set(safeProperties.map((p) => p.city))].filter(Boolean);
    const citiesCount = citiesList.map((city) => ({
        city: city,
        count: safeProperties.filter((p) => p.city === city).length,
    }));

    return (
        <div className="col-lg-4 mb-100">
            <aside className="sidebar ltn__shop-sidebar">
                {/* TYPE FILTER */}
                <div className="widget ltn__menu-widget">
                    <h4 className="ltn__widget-title">Tipe Properti</h4>
                    <ul>
                        {typeCount.map((t, i) => (
                            <li key={i}>
                                <label className="checkbox-item">
                                    {t.type}
                                    <input
                                        type="checkbox"
                                        checked={types.includes(t.type)}
                                        onChange={() => toggleFilter("types", t.type)}
                                    />
                                    <span className="checkmark" />
                                </label>
                                <span className="categorey-no">{t.count}</span>
                            </li>
                        ))}
                    </ul>
                    <hr />

                    {/* HARGA */}
                    <h4 className="ltn__widget-title">Rentang Harga</h4>
                    <ul>
                        {hargaCount.map((h, i) => (
                            <li key={i}>
                                <label className="checkbox-item">
                                    {h.label}
                                    <input
                                        type="checkbox"
                                        checked={harga.includes(h.key)}
                                        onChange={() => toggleFilter("harga", h.key)}
                                    />
                                    <span className="checkmark" />
                                </label>
                                <span className="categorey-no">
                                    {h.min === 0
                                        ? `${formatRupiah(h.min)} - ${formatRupiah(h.max)}`
                                        : h.max === Infinity
                                        ? `${formatRupiah(h.min)}+`
                                        : `${formatRupiah(h.min)} - ${formatRupiah(h.max)}`}
                                    {" (" + h.count + ")"}
                                </span>
                            </li>
                        ))}
                    </ul>
                    <hr />

                    {/* PROVINCES */}
                    <h4 className="ltn__widget-title">Provinsi</h4>
                    <ul>
                        {provincesCount.map((p, i) => (
                            <li key={i}>
                                <label className="checkbox-item">
                                    {p.province}
                                    <input
                                        type="checkbox"
                                        checked={provinces.includes(p.province)}
                                        onChange={() => toggleFilter("provinces", p.province)}
                                    />
                                    <span className="checkmark" />
                                </label>
                                <span className="categorey-no">{p.count}</span>
                            </li>
                        ))}
                    </ul>
                    <hr />

                    {/* CITIES */}
                    <h4 className="ltn__widget-title">Kota</h4>
                    <ul>
                        {citiesCount.map((c, i) => (
                            <li key={i}>
                                <label className="checkbox-item">
                                    {c.city}
                                    <input
                                        type="checkbox"
                                        checked={cities.includes(c.city)}
                                        onChange={() => toggleFilter("cities", c.city)}
                                    />
                                    <span className="checkmark" />
                                </label>
                                <span className="categorey-no">{c.count}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            </aside>
        </div>
    );
};

export default Sidebar;
